import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';
import {
  Question
} from '@phosphor-icons/react';

const Tooltip = ({ text, children, content }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);
  
  // Support both 'text' and 'content' props for backward compatibility
  const tooltipText = text || content;

  useEffect(() => {
    if (isVisible && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setPosition({
        top: rect.top - 8, // Position above trigger with small gap
        left: rect.left + rect.width / 2, // Center horizontally
      });
    }
  }, [isVisible]);

  return (
    <>
      <div 
        ref={triggerRef} 
        className="relative inline-block"
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
      >
        {children || (
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              setIsVisible(!isVisible);
            }}
            className="text-[#718096] hover:text-[#6366F1] transition-colors"
          >
            <Question size={18} />
          </button>
        )}
      </div>
      
      {/* Render tooltip in a portal at document body level */}
      {createPortal(
        <AnimatePresence>
          {isVisible && (
            <motion.div
              key="tooltip"
              initial={{ opacity: 0, y: 5 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 5 }}
              transition={{ duration: 0.2 }}
              style={{
                position: 'fixed',
                top: position.top,
                left: position.left,
                transform: 'translate(-50%, -100%)',
                zIndex: 99999,
                pointerEvents: 'none',
              }}
            >
              <div className="glass rounded-xl p-3 border border-[rgba(99,102,241,0.3)] max-w-xs shadow-2xl backdrop-blur-xl">
                <p className="text-[#A0AEC0] text-sm leading-relaxed">{tooltipText}</p>
              </div>
              {/* Arrow */}
              <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-1">
                <div className="w-2 h-2 rotate-45 bg-[rgba(99,102,241,0.3)] backdrop-blur-xl"></div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>,
        document.body
      )}
    </>
  );
};

export default Tooltip;
